import { render } from "./AppLogout.vue?vue&type=template&id=6dc6ca7c"
import script from "./AppLogout.vue?vue&type=script&lang=js"
export * from "./AppLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__